export default "__VITE_ASSET__DsPUjEd0__"